<template>
  <modal
    ref="collectionPointDeleteModal"
    title="Aviso"
    template="question"
    ref-name="collectionPointDeleteModal"
    first-button-text="CANCELAR"
    :icon-enabled="false"
    second-button-text="EXCLUIR"
    :close-button-enabled="false"
    :first-button-disabled="collectionPointBatchesLoading"
    :second-button-disabled="collectionPointBatchesLoading"
    class="collection-point-delete-modal"
    @first-cta="closeModal()"
    @second-cta="handleSecondButton()"
  >
    <div class="modal-content">
      <p>Tem certeza que deseja excluir o posto de coleta?</p>
      <div class="collectionPoint-name">
        <span>{{ collectionPoint.name }}</span>
      </div>
      <div 
        v-if="collectionPointBatchesLoading"
        class="modal-loading"
      >
        <loading />
      </div>
      <div
        v-if="showAlert()"
        class="collectionPoint-alert"
      >
        <span>Esse posto de coleta possui lotes ainda em aberto</span>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CollectionPointDeleteModal',
  data: () => ({
    collectionPoint: {},
    isloading: false
  }),
  methods: {
    ...mapActions(['collectionPointDelete']),
    ...mapActions(['collectionPointClearBatches']),
    closeModal () {
      this.collectionPointClearBatches()
      this.$refs.collectionPointDeleteModal.close()
    },
    handleSecondButton () {
      this.collectionPointDelete(this.collectionPoint.idCollectionPoint)
      this.closeModal()
    },
    openModal (collectionPoint) {
      if (collectionPoint) {
        this.collectionPoint = collectionPoint
      }
      this.$refs.collectionPointDeleteModal.open()
    },
    showAlert () {
      if (this.collectionPointBatchesLoading) {
        return false
      }
      if (this.collectionPointBatchesHasOpen) {
        return true
      }
      return false
    }
  },
  computed: {
    ...mapGetters(['collectionPointServiceStatus']),
    ...mapGetters(['collectionPointBatchesHasOpen']),
    ...mapGetters(['collectionPointBatchesLoading'])
  }
}
</script>

<style lang="scss">
.collection-point-delete-modal {
  .md-dialog {
    .md-dialog-title {
      .standard-modal {
        &__title {
          &:before {
            content: "";
            width: 18px;
            height: 18px;
            background-image: url('/static/images/alert-icon.svg');
            display: inline-block;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            margin: 0px 8px 0 0px;
          }
        }
      }
    }
    .md-dialog-content {
      .standard-modal {
        &__description {
          .modal-content {
            .modal-loading {
              padding: 20px 0 0;
            }
            .collectionPoint-name {
              text-align: center;
              padding: 15px;
              background: #F5F5F5;
              border-radius: 5px;
              span {
                font-weight: 500;
                font-size: 16px;
                color: #4A4A4A;
                letter-spacing: 0;
              }
            }
            .collectionPoint-alert {
              text-align: center;
              margin-top: 10px;
              background-color: #fdedd3;
              border-radius: 5px;
              padding: 10px;
              span {
                color: #4A4A4A;
                letter-spacing: 0;
                &:before {
                  content: "";
                  width: 16px;
                  height: 16px;
                  background-image: url(/static/images/alert-icon.svg);
                  display: inline-block;
                  background-repeat: no-repeat;
                  background-position: 50%;
                  background-size: contain;
                  margin: 0px 8px 0 0;
                  position: relative;
                  top: 2px;
                }
              }
            }
          }
        }
        &__container-cta {
          .btn-primary {
            background-color: #b40607;
            &:hover {
              background-color: #8c1011;
            }
          }
        }
      }
    }
  }
}
</style>
